import { api } from './api';

// Endpoints de usuários no escopo da store atual (MANAGER em /fornecedor/painel).
// A API resolve a store via X-Store-Slug + auth.
export const storeUsersService = {
  list: async (filters = {}) => {
    const qs = new URLSearchParams();
    ['status', 'role', 'q'].forEach((k) => {
      if (filters[k] !== undefined && filters[k] !== '') qs.set(k, filters[k]);
    });
    if (filters.active !== undefined && filters.active !== '') qs.set('active', filters.active);
    if (filters.page) qs.set('page', filters.page);
    if (filters.limit) qs.set('limit', filters.limit);
    const s = qs.toString();
    return api.get(`/api/store-users${s ? `?${s}` : ''}`);
  },

  get: async (userId) => api.get(`/api/store-users/${userId}`),

  create: async (payload) => api.post('/api/store-users', payload),

  update: async (userId, payload) => api.patch(`/api/store-users/${userId}`, payload),

  updateStatus: async (userId, payload) =>
    api.patch(`/api/store-users/${userId}/status`, payload),

  resetPassword: async (userId) =>
    api.post(`/api/store-users/${userId}/reset-password`, null)
};

export default storeUsersService;
